module.exports = __webpack_public_path__ + "static/media/about-us-1.70bd401a.jpg";